import { environment } from "../environments/environment";

// src/app/auth-config.ts
export const msalConfig = {
  auth: {
    // Application (client) ID from Azure AD  AD App Name: SPA - Sky Supplier Search
    clientId: environment.clientId,

    // Azure AD authority URL (tenant-specific)
    authority: environment.authority,

    // Redirect URI after authentication
    redirectUri: environment.appUrl /*Angular UI endpoint URL*/

    /*Enable for the localhost debug environment*/
    //redirectUri: 'http://localhost:4200/' 
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

// Scopes for login requests
export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "offline_access"
  ]
};

// =============================
// Protected API Resources Configuration
// =============================
export const protectedResources = {
  functionApi: {
    endpoint: environment.apiUrl, /*Function app endpoint URL*/

    /*Enable for the localhost environment*/
    //endpoint: 'http://localhost:7071/api/suppliers',

    scopes: [
      environment.apiScope /*API scope defined in Azure AD app registration*/
    ]
  },
};
